/* ============================================================================
   GO Industrial — Boost AI search overlay behaviour
   1. "Did you mean" clicks update the search input in-place (no navigation)
   2. Search-icon clicks on /search page open the Boost overlay instead of reloading
   ============================================================================ */
(function () {
  'use strict';

  // ------------------------------------------------------------------
  // Boost overlay helpers
  // ------------------------------------------------------------------

  function findBoostInput() {
    var selectors = [
      '[class*="boost-sd__search-widget-init-input"]',
      '.boost-sd__search-bar-wrapper input[type="search"]',
      '.boost-sd__search-bar-wrapper input[type="text"]',
      '[class*="boost-sd__search-bar-wrapper"] input'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        if (el.offsetParent !== null || el === document.activeElement) {
          return el;
        }
      }
    }
    return null;
  }

  function setInputValue(input, value) {
    var proto = Object.getPrototypeOf(input);
    var desc = proto && Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) {
      desc.set.call(input, value);
    } else {
      input.value = value;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function openBoostOverlay() {
    var input = findBoostInput();
    if (input) {
      try { input.focus(); } catch (e) { /* ignore */ }
      try { input.click(); } catch (e) { /* ignore */ }
      input.dispatchEvent(new Event('focus', { bubbles: true }));
      return true;
    }

    // Fallback: click any Boost trigger button
    var trigger = document.querySelector(
      '[class*="boost-sd__search-trigger"], ' +
      'button[class*="boost-sd__search"]'
    );
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  // ------------------------------------------------------------------
  // 1. Did-you-mean: update input value instead of navigating
  // ------------------------------------------------------------------

  function handleDidYouMeanClick(e) {
    var link = e.target.closest(
      '[class*="boost-sd__spelling-correction"] a, ' +
      '[class*="boost-sd__did-you-mean"] a'
    );
    if (!link) return;

    var suggestion = (link.textContent || '').trim();
    if (!suggestion) return;

    e.preventDefault();
    e.stopPropagation();

    var input = findBoostInput();
    if (input) {
      setInputValue(input, suggestion);
      try { input.focus(); } catch (e2) { /* ignore */ }
    }
  }

  // ------------------------------------------------------------------
  // 2. Search-icon on /search: open overlay instead of reloading
  // ------------------------------------------------------------------

  function isOnSearchPage() {
    var path = window.location.pathname || '';
    return path === '/search' || path.indexOf('/search/') === 0 || path.indexOf('/search') === 0 && path.indexOf('?') === 6;
  }

  function handleSearchIconClick(e) {
    var link = e.target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (!href) return;

    // Only intercept the header search-icon click: a bare /search link with NO
    // query string. Pagination, sort, filter, overlay suggestions, and the
    // view-all-results button all have `?` in their href and must navigate
    // normally. The header icon is `<a href="{{ routes.search_url }}">` which
    // renders as `/search` (or locale-prefixed `/en/search`).
    if (href.indexOf('?') !== -1) return;
    var path = href.split('#')[0].replace(/\/$/, '');
    if (!/(^|\/)search$/.test(path)) return;

    if (!isOnSearchPage()) return;

    if (openBoostOverlay()) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  // ------------------------------------------------------------------
  // Bind delegated listeners
  // ------------------------------------------------------------------

  document.addEventListener('click', handleDidYouMeanClick, true);
  document.addEventListener('click', handleSearchIconClick, true);
})();
